import { ca } from '@cian/analytics';
import { IAnalyticsUser, TPage, TPageExtra } from '../../types/analytics';
import { formatPhoneForAnalytics } from '../formatters';

/**
 * Заполнение поля “напишите пожелания”
 * https://conf.cian.tech/pages/viewpage.action?pageId=1319910433
 */
export const trackRequirementsFill = (
  userPhone: string | null,
  inputPhone: string,
  analyticsUser: IAnalyticsUser,
  page: TPage,
  extra: TPageExtra,
  wishes?: string | null,
) => {
  ca('eventSite', {
    action: 'Fill_sopr',
    category: 'newbuilding_finder',
    label: 'search_wishes',
    name: 'oldevent',
    page: {
      ...page,
      extra: {
        wishes,
        ...extra,
      },
    },
    user: {
      ...analyticsUser,
      extra: {
        phone: userPhone ? formatPhoneForAnalytics(userPhone) : undefined,
        phone_fill: formatPhoneForAnalytics(inputPhone),
      },
    },
  });
};
